import { Link } from "@mui/material";

// A DOI resolves through doi.org to the publisher's page for the publication.
const DoiLink = ({ doi }) =>
  doi ? (
    <Link
      href={`https://doi.org/${doi}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={event => event.stopPropagation()}
    >
      {doi}
    </Link>
  ) : (
    "-"
  );

export default DoiLink;
